import React, { useContext, useRef } from "react";
import "../../styles/socialMediaSection.css";
import { WebsiteContext } from "../../context/AppContext";
import CountUp from "react-countup";
import { FaYoutube, FaInstagram, FaGooglePlay } from "react-icons/fa6";
import { FiArrowUpRight } from "react-icons/fi";
import { motion, useInView } from "framer-motion";

const socialChannels = [
  {
    platform: "youtube",
    handle: "English With Reena",
    count: 45200,
    formattedDisplay: "45.2K+",
    metric: "Subscribers",
    icon: <FaYoutube />,
    bubbleClass: "yt_bubble",
    countClass: "yt_count",
    btnClass: "yt_btn",
    cardClass: "youtube_card",
    ctaLabel: "Watch on YouTube",
    link: "https://www.youtube.com/@reena_english",
  },
  {
    platform: "instagram",
    handle: "english_with_reena",
    count: 224000,
    formattedDisplay: "224K+",
    metric: "Followers",
    icon: <FaInstagram />,
    bubbleClass: "ig_bubble",
    countClass: "ig_count",
    btnClass: "ig_btn",
    cardClass: "instagram_card",
    ctaLabel: "Follow on Instagram",
    link: "https://www.instagram.com/english_with_reena/",
  },
  {
    platform: "app",
    handle: "Fluent Fable App",
    count: 5000,
    formattedDisplay: "5K+",
    metric: "Active Downloads",
    icon: <FaGooglePlay />,
    bubbleClass: "app_bubble",
    countClass: "app_count",
    btnClass: "app_btn",
    cardClass: "app_card",
    ctaLabel: "Get on Google Play",
    link: "https://play.google.com/store/apps/details?id=com.fluentfable&hl=en",
  },
];

const SocialMediaSection = () => {
  const { color, dark } = useContext(WebsiteContext);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <div className="social_section_wrapper" ref={ref}>
      {/* Header */}
      <div className="social_header">
        <span className={`social_badge ${dark ? "social_badge_dark" : "social_badge_light"}`}>
          🌐 Global Community
        </span>
        <h2 className="social_title" style={{ color: color }}>
          Our Social Media Engagement
        </h2>
        <p className="social_subtitle" style={{ color: color }}>
          Join over 270,000+ passionate learners across YouTube, Instagram, and the Fluent Fable App mastering English every single day.
        </p>
      </div>

      {/* 3-Card Grid */}
      <div className="social_cards_grid">
        {socialChannels.map((item, index) => (
          <motion.a
            key={item.platform}
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.35, delay: index * 0.1 }}
            className={`social_card ${item.cardClass} ${dark ? "social_card_dark" : "social_card_light"}`}
          >
            {/* Platform Icon Bubble */}
            <div className={`social_icon_bubble ${item.bubbleClass}`}>
              {item.icon}
            </div>

            {/* Handle Name */}
            <h3 className="social_handle" style={{ color: color }}>
              {item.handle}
            </h3>

            {/* Animated Count */}
            <div className="social_count_wrap">
              <span className={`social_count_number ${item.countClass}`}>
                {isInView && (
                  <CountUp
                    start={0}
                    end={item.count}
                    duration={2.5}
                    separator=","
                  />
                )}
                +
              </span>
            </div>

            <span className="social_count_label" style={{ color: color }}>
              {item.metric}
            </span>

            {/* CTA Button */}
            <div className={`social_cta_btn ${item.btnClass}`}>
              <span>{item.ctaLabel}</span>
              <FiArrowUpRight size={15} />
            </div>
          </motion.a>
        ))}
      </div>
    </div>
  );
};

export default SocialMediaSection;
